<template>
    <u-txt-default class="line-height-15">
        <v-row no-gutters >
            <v-col cols="auto">
                <p class="pr-4px pr-md-8px">·</p>
            </v-col>
            <v-col>
                <p><slot /></p>
            </v-col>
        </v-row>
    </u-txt-default>
</template>

<script>
import UTxtDefault from "@/components/publish/styles/typography/u-txt-default.vue";
export default {
    props:{
    },
    components: {
        UTxtDefault
    },
}
</script>

<style>

</style>